import React, { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import CoreLayout from '../../layouts/CoreLayout/CoreLayout'
import { buildV3Location } from '../locationUtils'
import { fetchUserImage } from 'store/user'

let userImageFetchAttempted = false
let currentUserId = null

export default function CoreLayoutRoute({ store }) {
  const location = useLocation()
  const params = useParams()
  const v3Location = buildV3Location(location, params)

  useEffect(() => {
    const state = store.getState()
    const { user } = state
    const hasUser = Object.keys(user).length !== 0

    if (hasUser && currentUserId !== user.id) {
      userImageFetchAttempted = false
      currentUserId = user.id
    } else if (!hasUser) {
      userImageFetchAttempted = false
      currentUserId = null
    }

    if (hasUser && !user.userImage && !userImageFetchAttempted) {
      userImageFetchAttempted = true
      store.dispatch(fetchUserImage(user.id))
    }
  }, [store, location.pathname])

  return (
    <CoreLayout location={v3Location} params={params}>
      <Outlet />
    </CoreLayout>
  )
}
